import React, { useEffect, useRef } from "react";
import { Header, Footer } from "./pages/StaticPages";
import { Outlet, useLocation } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

// ✅ Register both plugins before use
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const PublicLayoutRoute = () => {
  const isHomeSection = useLocation().pathname === "/";
  const isAboutsSection = useLocation().pathname === "/about-us";
  const location = useLocation();

  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
    // useEffect(() => {
    //   // Ensure DOM elements exist
    //   if (!wrapperRef.current || !contentRef.current) return;

    //   // ✅ Create smoother instance only once per mount
    //   const smoother = ScrollSmoother.create({
    //     wrapper: wrapperRef.current,
    //     content: contentRef.current,
    //     smooth: 2.05,    // Adjust for smoother scroll (lower = snappier)
    //     effects: true,  // Enable parallax and fade effects if defined in markup
    //   });

    //   return () => {
    //     // ✅ Kill smoother on cleanup to avoid memory leaks
    //     smoother.kill();
    //   };
    // }, []);

  useEffect(() => {
    const section = document.querySelector(".one");

    ScrollTrigger.create({
      trigger: section,
      start: "-50%",
      end: "bottom+=100% top", // how long it stays pinned
      pin: true,
      pinSpacing: false, // 🧹 removes that extra space
      scrub: true,
    });

    return () => ScrollTrigger.getAll().forEach(t => t.kill());
  }, []);


//   useEffect(() => {
//   const section = document.querySelector(".how-it-works-section-step");

//   ScrollTrigger.create({
//     trigger: section,
//     start: "-10%",
//     end: "bottom+=100% bottom", // how long it stays pinned
//     pin: true,
//     pinSpacing: false, // 🧹 removes that extra space
//     scrub: true,
//   });

//   return () => ScrollTrigger.getAll().forEach(t => t.kill());
// }, []);


  useEffect(() => {
    const smoother = ScrollSmoother.get();

    setTimeout(() => {
      if (smoother) {
        smoother.scrollTo(0, true);  // forces scroll to top
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 50); // small delay fixes GSAP timing issue
  }, [location.key]);

  return (
    // 👇 Required GSAP structure
    // <div ref={wrapperRef} id="smooth-wrapper" style={{ overflow: "hidden" }}>
      <div ref={contentRef} id="smooth-content">
        <div className="static-container">
          {!isHomeSection && <Header />}
          <Outlet />
          {(!isHomeSection && !isAboutsSection) && <Footer />}
        </div>
      </div>
    // </div>
  );
};

export default PublicLayoutRoute;
